<template>
    <div class="container">
        <div class="content">
            <!-- <h3>角色</h3>
            <h4>数据筛选</h4> -->
            <div>
                <el-form :inline="true" :model="roleForm" :rules="roleRules" ref="roleForm" label-width="64px" size="small"
                    class="search-form">
                    <el-form-item label="角色">
                        <template #label>
                            角<span class="space"></span>色
                        </template>
                        <el-input v-model="roleForm.name" placeholder="请输入角色名称"></el-input>
                    </el-form-item>
                    <!-- <el-form-item>
                        <el-button type="primary" size="mini" plain @click="submitForm('roleForm')">查询
                        </el-button>
                        <el-button type="primary" size="mini" plain @click="resetForm('roleForm')">重置
                        </el-button>
                    </el-form-item> -->
                    <el-form-item style="float: right;margin-right: 0;">
                        <div style="display: flex;">
                            <div class="s-btn" @click="submitForm('roleForm')">查询</div>
                            <div class="r-btn" @click="resetForm('roleForm')">重置</div>
                        </div>

                    </el-form-item>
                </el-form>
            </div>
            <div class="line"></div>
            <div class="data-title">
                <div style="display: flex;height: 32px;">
                    <div class="title-line"></div>
                    <div class="title-name">数据列表</div>
                </div>

                <div class="title-btn">
                    <div class="title-btn-item" @click="openAdiog" v-if="parArray.indexOf('roleadd_oa') != -1">
                        <i class="el-icon-plus"></i>
                        <div class="btn-l">新增角色</div>
                    </div>
                </div>
            </div>
            <lb-table :column="column" :data="roleList" pagination :total="page.totalNum"
                layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                :current-page.sync="page.currentPage" :page-size="page.pageSize" @size-change="handleSizeChange"
                @p-current-change="handleCurrentChange">
            </lb-table>
        </div>
        <!-- 管理客户等级 -->

        <!-- ============================= el-dialog ============================= -->

        <el-dialog title="关联权限组" :visible.sync="dialog.visible" width="694px" :append-to-body="true"
            :before-close="handleClose" :filterable="true">
            <div class="dialog-content">
                <el-transfer v-model="permissionSelected" :data="permissionAllList" :titles="['未选择', '已选择']">
                </el-transfer>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialog.visible = false">取 消</el-button>
                <el-button type="primary" @click="dialogConfirm">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog :visible.sync="dialogFormVisible" :append-to-body="true" :title="title" width="600px">
            <el-form :model="form" :rules="rules" ref="form" size="small" class="elForm">
                <el-form-item label-width="100px" label="角色名称" prop="name">
                    <el-input show-word-limit maxlength="12" v-model="form.name" placeholder="请输入角色名称"
                        size="small"></el-input>
                </el-form-item>
                <!--        <el-form-item :label-width="formLabelWidth" label="角色描述">
            <el-input
                maxlength="20"
                type="textarea"
                v-model="form.remark"
                placeholder="请输入角色描述"
            ></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="状态">
            <el-radio v-model="form.status" label="A">开启</el-radio>
            <el-radio v-model="form.status" label="S">禁用</el-radio>
          </el-form-item>-->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" :loading="btnloading" @click="
                    updateBattery();
                ">确 定
                </el-button>
            </div>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="isConfirm" width="268px" append-to-body>
            <div style="font-size: 14px;color: #2F3030;line-height: 22px;text-align: center;margin-left:12px">
                是否确认删除该角色？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isConfirm = false">取 消</el-button>
                <el-button type="primary" @click="qDelete()">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import LbTable from '../../components/lb-table/lb-table'

export default {
    name: 'role',
    components: {
        LbTable,
    },
    data() {
        return {
            isConfirm: false,
            permissionAllList: [],
            permissionSelected: [],
            column: [{
                label: '角色',
                prop: 'name',
                renderHeader: (h, scope) => {
                    return (
                        <div style="display:flex;justify-content:flex-start">角色</div>
                    )
                },
                render: (h, scope) => {
                    return (
                        <div style="display:flex;justify-content:flex-start">{scope.row.name}</div>
                    )
                }
            }, {
                label: '角色创建类型',
                prop: 'winTypeLabel',
                 minWidth: 120,

            }, {
                label: '权限组',
                prop: 'authListStr',
                minWidth: 200,
                renderHeader: (h, scope) => {
                    return (
                        <div style="display:flex;justify-content:flex-start">权限组</div>
                    )
                },
                render: (h, scope) => {
                    return (
                        <div style="display:flex;justify-content:flex-start">{scope.row.authListStr}</div>
                    )
                }
            },
            {
                label: '最后更新时间',
                prop: 'updatedTime',
                minWidth: 170,
                renderHeader: (h, scope) => {
                    return (
                        <div style="display:flex;justify-content:flex-start">最后更新时间</div>
                    )
                },
                render: (h, scope) => {
                    return (
                        <div style="display:flex;justify-content:flex-start">{scope.row.updatedTime}</div>
                    )
                }
            },
            {
                label: '操作',
                width: 160,
                fixed:"right",
                render: (h, scope) => {
                    return (
                        <div style="display:flex;justify-content:center">
                            <div
                                style="color:#00B498;cursor:pointer;"
                                onClick={() => {
                                    this.showDialog(scope.$index, scope.row)
                                }}>查看/绑定<span style="margin-right:4px"></span>
                            </div>
                            {
                                this.parArray.indexOf('fixrole_oa') != -1 && !scope.row.dingId ? <div
                                    style="color:#00B498;cursor:pointer;"
                                    onClick={() => {
                                        this.fixRole(scope.row);
                                        this.dialogFormVisible = true;
                                    }}>修改<span style="margin-right:4px"></span>
                                </div> : ""
                            }
                            {
                                this.parArray.indexOf('roleDelect_oa') != -1 && !scope.row.dingId ? <div
                                    style="color:#f40713;cursor:pointer;"
                                    onClick={() => {
                                        this.deleteRole(scope.row);
                                    }}>删除
                                </div> : ""
                            }
                        </div>
                    )
                }
            }],
            roleForm: {
                name: ''
            },
            roleRules: {
                name: [
                    { required: true, message: '请输入角色名称', trigger: 'blur' },
                    { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
                ],
            },
            page: {
                pageNo: 1,
                pageSize: 10,
                totalNum: 0,
                currentPage: 1,
            },
            roleList: [],
            dialog: {
                visible: false,
                title: ''
            },
            currentRow: {},
            parArray: [], // 按钮权限
            dialogFormVisible: false,
            formLabelWidth: "120px",
            btnloading: false,
            form: {
                name: "",
                status: "A"
            },
            rules: {
                name: [
                    { required: true, message: '请输入角色名称', trigger: "blur" },
                ],
            },
            roleId: "",
            title: "新增角色",
            dId: ""
        };
    },
    created() {
        this.getButtonTreeDto() // 获取权限设定
        this.fetchData()

        // 权限设定判断 normsCode
        this.limits = JSON.parse(sessionStorage.getItem("limit"));
        const params = this.limits.buttonTreeDto.filter(
            (item) => item.menuCode === "role"
        );
        params[0].buttonList.forEach((item) => {
            this.parArray.push(item.code);
        });
        // 权限设定判断 normsCode
    },
    methods: {
        qDelete() {
            this.$api.removeRole({ id: this.dId }).then(res => {
                // console.log(res)
                if (res.code == 0) {
                    this.$message.success("删除成功");
                    this.fetchData()
                    this.isConfirm = false
                }
            })
        },
        getButtonTreeDto() {
            // 获取权限设定
            this.limits = JSON.parse(sessionStorage.getItem('limit'))
            const params = this.limits.buttonTreeDto.filter(
                (item) => item.menuCode === 'role'
            )
            params[0].buttonList.forEach((item) => {
                this.parArray.push(item.code)
            })
            console.log(this.parArray)
        },
        fetchData(type) {
            if (type == 'search') {
                this.page.pageNo = 1
            }
            const params = {
                id: sessionStorage.getItem("user_id"),
                name: this.roleForm.name,
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize
            }
            this.$api.rolePageList(params).then((res) => {
                res.data.list.map((e) => {
                    let str = ''
                    e.authList.forEach(e => {
                        str += `${e.name}、`
                    });
                    e.authListStr = str.substring(0, str.length - 1)
                    if (e.authList.length == 0) {
                        e.authListStr = '-'
                    }
                })
                this.roleList = res.data.list
                this.page.totalNum = res.data.totalNum
                // if (res.data.list.length === 0) {
                //     Message.warning('没有搜索出相关内容');
                // }
            }).catch((err) => {
                console.log(err)
            })
        },
        handleCurrentChange(currentChange) {
            this.page.pageNo = currentChange
            this.fetchData()
        },
        handleSizeChange(sizeChange) {
            this.page.pageSize = sizeChange
            this.fetchData()
        },
        // 显示  dialog
        showDialog(index, row) {
            // console.log(index, row)
            this.currentRow = row
            this.dialog.visible = true
            this.getPermissionAllList(row)
            this.setPermissionSelected(row)
        },
        // 权限组列表查询
        getPermissionAllList(row) {
            if (this.permissionAllList.length === 0) {
                this.$api.permissionAllList().then((res) => {
                    res.data.forEach((e) => {
                        e.key = e.id
                        e.label = e.name
                    })
                    this.permissionAllList = res.data
                    this.setPermissionSelected(row)
                }).catch((err) => {
                    console.log(err)
                })
            }
        },
        setPermissionSelected(row) {
            let arr = []
            this.permissionAllList.forEach((e) => {
                row.authList.forEach((ee) => {
                    if (e.name == ee.name) {
                        arr.push(e.id)
                    }
                })
            })
            this.permissionSelected = arr
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => {
                });
        },
        dialogConfirm() {
            this.$confirm('是否确认修改权限？')
                .then(_ => {
                    this.dialog.visible = false
                    this.setRoleUpdateAuth()
                })
                .catch(_ => {
                });
        },
        // 修改角色绑定权限组
        setRoleUpdateAuth(row) {
            if (this.parArray.indexOf("rolefp_oa") == -1) {
                return this.$message({ type: 'warning', message: '权限不足!' });
            }
            let data = {
                roleId: this.currentRow.id,
                authList: this.permissionSelected
            }
            this.$api.roleUpdateAuth(data).then((res) => {
                this.fetchData()
                this.$message.success("操作成功！");
                console.log(res)
            }).catch((err) => {
                console.log(err)
            })
        },
        // 搜索 表单验证
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.fetchData('search')
                    // this.dialog.visible = false;
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 重置搜索
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.roleForm.name = ''
            this.page.pageNo = 1
            this.page.pageSize = 10
            this.totalNum = 0
            this.page.currentPage = 1
            this.fetchData()
        },
        openAdiog() {
            this.dialogFormVisible = true;
            this.title = "新增角色";
            this.roleId = "";
            this.form = {
                name: "",
                remark: "",
                status: "A"
            };
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        // 修改角色
        fixRole(row) {
            console.log(row);
            this.roleId = row.id;
            this.title = "修改角色";
            this.form = {
                name: row.name,
                remark: "",
                status: "A"
            };
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        // 删除组织
        deleteRole(row) {
            this.isConfirm = true
            this.dId = row.id
            // this.$confirm('确定要删除该角色吗, 是否继续?', '提示', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            // }).then(() => {
            //     this.$api.removeRole({ id: row.id }).then(res => {
            //         // console.log(res)
            //         if (res.code == 0) {
            //             this.$message.success("删除成功");
            //             this.fetchData()
            //         }
            //     })
            // }).catch(() => {
            //     this.$message({
            //         type: 'info',
            //         message: '已取消删除'
            //     });
            // });
        },
        // 停用启动
        //添加管理员的数据
        updateBattery() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.btnloading = true;
                    if (this.form.name == "") {
                        this.$message.warning("角色名称为空");
                    } else if (this.form.status == "") {
                        this.$message.warning("角色状态为空");
                    } else {
                        if (this.roleId == "" || this.roleId == undefined) {
                            this.axios
                                .post(
                                    "/sys/v1/role/add",
                                    {
                                        request: {
                                            remark: this.form.remark,
                                            roleName: this.form.name,
                                            userId: sessionStorage.getItem("user_id"),
                                        },
                                        version: "",
                                    },
                                    {
                                        headers: {
                                            isLoading: false,
                                        },
                                    }
                                )
                                .then((res) => {
                                    this.btnloading = false;
                                    if (res.code == 0) {
                                        this.$message.success("添加成功");
                                        this.form = { name: "", remark: "", status: "A" };
                                        this.fetchData()
                                        this.dialogFormVisible = false
                                    } else {
                                        this.$message.error(res.message);
                                    }
                                });
                        } else {
                            this.axios
                                .post(
                                    "/sys/v1/role/update",
                                    {
                                        request: {
                                            roleId: this.roleId,
                                            remark: this.form.remark,
                                            roleName: this.form.name,
                                            status: this.form.status,
                                            userId: sessionStorage.getItem("user_id"),
                                        },
                                        version: "",
                                    },
                                    {
                                        headers: {
                                            isLoading: false,
                                        },
                                    }
                                )
                                .then((res) => {
                                    this.btnloading = false;
                                    if (res.code == 0) {
                                        this.$message.success("修改成功");
                                        this.fetchData()
                                        this.dialogFormVisible = false
                                    } else {
                                        this.$message.error(res.message);
                                    }
                                });
                        }
                    }
                }
            })

        },
    }
}
</script>
  
<style scoped lang="scss">
.data-title {
    width: 100%;
    height: 32px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-line {
        width: 2px;
        height: 16px;
        background: #00B498;
        border-radius: 0px 0px 0px 0px;
        margin-top: 8px;
    }

    .title-name {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #2F3030;
        margin-left: 4px;
        line-height: 32px;
    }

    .title-btn {
        display: flex;

        .title-btn-item {
            width: 92px;
            height: 32px;
            background: #FFFFFF;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #E3E6E5;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 8px;
            padding-right: 8px;
            box-sizing: border-box;
            cursor: pointer;

            .btn-l {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #2F3030;

            }
        }


    }
}

.line {
    width: 100%;
    height: 1px;
    background: #EDF2F2;
    border-radius: 0px 0px 0px 0px;
    clear: both;
    // margin-top: 16px;
}

// .div1 {
//     margin-left: -16px;
//     background: url(../../../assets/breadcrumb2.png);
//     width: 120px;
//     height: 30px;
//     text-align: center;
//     line-height: 30px;
//     color: #2d7edf;
// }

// .div2 {
//     margin-left: -16px;
//     background: url(../../../assets/breadcrumb1.png);
//     width: 120px;
//     height: 30px;
//     text-align: center;
//     line-height: 30px;
//     color: #fff;
// }

// .div3 {
//     margin-left: -8px;
//     background: url(../../../assets/breadcrumb3.png);
//     width: 120px;
//     height: 30px;
//     text-align: center;
//     line-height: 30px;
//     color: #2d7edf;
// }
/deep/.el-link.el-link--primary:hover {
    color: #00B498;
}

/deep/.el-link.el-link--primary {
    color: #00B498;
}

.content {
    padding: 32px 16px 16px;
    background-color: #ffffff;
    min-height: calc(100vh - 118px);
    box-sizing: border-box;
    border-bottom: 32px solid #F5FAF9;
    border-radius: 8px 8px 8px 8px / 8px 8px 40px 40px;

    h3 {
        position: relative;
        margin-bottom: 20px;
        padding-left: 10px;

        &:before {
            position: absolute;
            top: 5px;
            left: 0;
            display: inline-block;
            content: "";
            width: 3px;
            height: 20px;
            background-color: #00B498;
        }
    }

    h4 {
        padding-top: 10px;
        border-top: 1px solid #bbbbbb;
    }
}
.elForm {
    padding: 20px 10px;
    /deep/{
        .el-input__inner,
        .el-textarea__inner{ 
            padding-left: 8px;
        }
        .el-form-item__label{
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
        }
    }
    
}
</style>
  